/**
 * Schemas Zod compartidos entre frontend y edge functions.
 *
 * Todo input externo se valida con Zod. El tipo TS deriva del schema:
 *   type Group = z.infer<typeof groupSchema>
 *
 * Los schemas viven aquí para que Edge Functions (Deno) y Vite (frontend)
 * los importen desde el mismo lugar y validen con la MISMA lógica.
 */

import { z } from 'zod';
import { CURRENCY_CODES } from '../currencies';

export const uuidSchema = z.string().uuid();

export const currencyCodeSchema = z.enum(CURRENCY_CODES as [string, ...string[]]);

export const emailSchema = z.string().email().max(254);

export const isoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

// Los ocho de la web. **La lectura de `participants.preferred_locale` NO usa
// este enum** —va a `z.string()`, ver ADR-0064—: la columna la comparte el
// cliente nativo y puede traer un idioma que aqui no este. Esto es lo que la web
// se permite **escribir**.
export const localeSchema = z.enum(['es', 'en', 'ca', 'de', 'eu', 'gl', 'fr', 'pt']);

// Placeholder para schemas por entidad. Se irán añadiendo en cada sprint.
// Ver docs/decisions/0008-shared-zod-schemas.md
